import { Component, OnInit } from '@angular/core';
import { FormsClient, FormsFlag } from '@benefitsui/app/api/benefits-clients';
import { FormsService } from './forms.service';
import { FormCellItemType, stateList } from './forms-page.types';
import { TableData } from '@dxo/ng-swift-ui';
import { DropdownOption } from '@benefitsui/app/lib/common.types';

@Component({
  selector: 'app-claims-page',
  templateUrl: './claims-page.component.html',
  styleUrls: ['./claims-page.component.scss']
})
export class ClaimsFormsPageComponent implements OnInit {
  constructor(
    private formsClient: FormsClient,
    private formsService: FormsService
  ) {}

  isLoading = true;
  selectStateBodyHeader = "Select employee's resident state";
  selectState = 'All';
  costomerDataTable!: TableData;
  claimDataTable!: TableData;
  claimsBodyHeader = 'Claim packets';
  customerBodyHeader = 'Customer claims forms';
  statesDropdown: DropdownOption<string>[] = stateList;
  showCustomer = false;
  showClaims = false;
  hasClaims = false;

  ngOnInit(): void {
    this.fillData();
    this.showClaims = false;
    this.showCustomer = false;
  }

  onFilterChange(value: string) {
    this.selectState = value;
    this.fillData();
    if (value === 'All') {
      this.showClaims = false;
    } else if (this.hasClaims) {
      this.showClaims = true;
    }
  }

  fillData(): void {
    this.formsClient.allForms(this.selectState).subscribe((response) => {
      this.formsService.setFormsData(response.data?.claimsForms as FormCellItemType[], FormsFlag.ClaimsForm);
      this.formsService.setFormsData(response.data?.customForms as FormCellItemType[], FormsFlag.CustomerForm);
      const claimsFormsData = this.formsService.getFormsData(FormsFlag.ClaimsForm);
      const costomerFormsData = this.formsService.getFormsData(FormsFlag.CustomerForm);
      if (claimsFormsData) {
        if (claimsFormsData.length > 0) {
          this.hasClaims = true;
        }
        this.claimDataTable = this.formsService.transformData(claimsFormsData);
      }
      if (costomerFormsData) {
        this.costomerDataTable = this.formsService.transformData(costomerFormsData);
      }
    });
    this.isLoading = false;
  }
}
